import { SidebarSectionType, StepTipType } from 'data/types';

const getStepText = (
  textKeys: Record<string, string>,
  stepId: string,
  field: `tip_${number}_title` | `tip_${number}_description`,
  fallback: string
) => {
  return textKeys[`step_${stepId}_${field}`] ?? fallback;
};

type ChooseSystemsTipSectionsArgs = {
  textKeys: Record<string, string>;
  ready: boolean;
};

export function getChooseSystemsTipSections({
  textKeys,
  ready
}: ChooseSystemsTipSectionsArgs): SidebarSectionType[] {
  const tips: StepTipType[] = ready
    ? [
        {
          targets: ['system-list-rail'],
          title: getStepText(
            textKeys,
            'choose_systems',
            'tip_1_title',
            'Browse your system options'
          ),
          description: getStepText(
            textKeys,
            'choose_systems',
            'tip_1_description',
            'These are complete systems that fit your design, with our top picks first. Use Sort by to reorder them, and click any card to open its full details.'
          )
        },
        {
          targets: ['system-filters-panel'],
          title: getStepText(
            textKeys,
            'choose_systems',
            'tip_2_title',
            'Narrow the list'
          ),
          description: getStepText(
            textKeys,
            'choose_systems',
            'tip_2_description',
            'Filter by configuration, price, efficiency, equipment types, and more \u2014 the list updates as you go. Reset brings everything back.'
          )
        },
        {
          targets: ['comparison-tabs'],
          title: getStepText(
            textKeys,
            'choose_systems',
            'tip_3_title',
            'Compare your favorites'
          ),
          description: getStepText(
            textKeys,
            'choose_systems',
            'tip_3_description',
            "Click Compare on a system card to add it here. Once you've added a few, use Compare Side by Side to view them next to each other."
          )
        }
      ]
    : [];

  return [
    {
      id: 'choose_systems',
      title: 'Choose Systems',
      description: '',
      steps: [
        {
          id: 'choose_systems',
          title: 'Choose Systems',
          description: '',
          status: 'incomplete',
          tips
        }
      ]
    }
  ];
}

export function getComparisonModalTipSections(
  textKeys: Record<string, string>
): SidebarSectionType[] {
  return [
    {
      id: 'choose_systems_comparison',
      title: 'Compare Selected Systems',
      description: '',
      steps: [
        {
          id: 'choose_systems_comparison',
          title: 'Compare Selected Systems',
          description: '',
          status: 'incomplete',
          tips: [
            {
              targets: ['comparison-modal-content'],
              title: getStepText(
                textKeys,
                'choose_systems_comparison',
                'tip_1_title',
                'Your side-by-side view'
              ),
              description: getStepText(
                textKeys,
                'choose_systems_comparison',
                'tip_1_description',
                'Each column is one system \u2014 swap a column for a different system, remove ones you rule out, and scan the rows to spot the differences.'
              )
            }
          ]
        }
      ]
    }
  ];
}
